// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2R5Pi","signatureBlock":"Footer_signatureBlock__1Vx-p","signature":"Footer_signature__1we6R"};